module.exports = __webpack_public_path__ + "img/15.01dd9ab7.jpg";